import React, { useState } from "react";
import { Sparkles, Check } from "lucide-react";
import api from "@/lib/api";

// Inline AI action. Calls /ai/generate and passes result to onResult.
export default function AIButton({ task, getInput, getContext, onResult, label = "Synthesize", testid }) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const run = async () => {
    setLoading(true); setError(""); setDone(false);
    try {
      const input = getInput ? getInput() : "";
      const context = getContext ? getContext() : "";
      const { data } = await api.post("/ai/generate", { task, input, context });
      onResult(data.output);
      setDone(true);
      setTimeout(() => setDone(false), 2000);
    } catch (e) {
      setError(e.response?.data?.detail || "AI is unavailable right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inline-flex flex-col items-start">
      <button
        type="button"
        data-testid={testid}
        onClick={run}
        disabled={loading}
        className={`group inline-flex items-center gap-2 rounded-sm border border-brand-sage/40 bg-brand-sage/10 px-3.5 py-2 text-sm text-stone-700 transition-all duration-300 hover:bg-brand-sage/20 hover:-translate-y-0.5 disabled:opacity-60 ${loading ? "ai-thinking" : ""}`}
      >
        {done ? <Check size={15} className="text-brand-sage" /> : <Sparkles size={15} strokeWidth={1.6} className="text-brand-sage" />}
        <span>{loading ? "Synthesizing\u2026" : label}</span>
      </button>
      {error && <span className="mt-1 text-xs text-[#9E4A41]">{error}</span>}
    </div>
  );
}
